import dialogChangePassword from './dialogChangePassword';

const subscribe = (store) => {
  dialogChangePassword.subscriber.subscribe(store);
};

export default {
  subscribe,
};
